import { schema } from 'normalizr';

export const referralSourceSchema = new schema.Entity('referralSource');
